import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';
export function FAQSection() {
  const faqs = [{
    q: '¿Necesito una PC potente?',
    a: 'No, te enseñamos a optimizar OBS para cualquier equipo, priorizando la fluidez de la transmisión sobre gráficos innecesarios.'
  }, {
    q: '¿Tengo que mostrar mi cara?',
    a: 'Es recomendable para crear conexión más rápido, pero incluimos tácticas específicas y probadas para triunfar como streamer sin cámara (VTubing básico o narración inmersiva).'
  }, {
    q: '¿Cuánto tiempo al día necesito?',
    a: 'Con 2 horas de stream bien ejecutadas y 30 minutos de creación de contenido vertical es suficiente para ver crecimiento.'
  }, {
    q: '¿Funciona para consola?',
    a: 'Sí, las estrategias de retención, psicología del espectador y creación de comunidad son universales, sin importar desde dónde juegues.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-24 px-4 sm:px-6 lg:px-8 bg-gaming-bg" data-id="element-34">
      <div className="max-w-3xl mx-auto" data-id="element-35">
        <div className="text-center mb-16" data-id="element-36">
          <h2 className="font-orbitron text-3xl md:text-4xl font-bold text-white mb-4" data-id="element-37">
            Preguntas Frecuentes
          </h2>
          <div className="w-16 h-1 bg-gaming-cyan mx-auto rounded-full box-glow-cyan" data-id="element-38" />
        </div>

        <div className="space-y-4" data-id="element-39">
          {faqs.map((faq, index) => <div key={index} className={`border ${openIndex === index ? 'border-gaming-purple/50 bg-gaming-card' : 'border-gray-800 bg-gaming-bg'} rounded-lg transition-all duration-300 overflow-hidden`} data-id="element-40">
              <button className="w-full px-6 py-5 flex items-center justify-between text-left focus:outline-none" onClick={() => setOpenIndex(openIndex === index ? null : index)} data-id="element-41">
                <span className="font-orbitron font-bold text-white text-lg" data-id="element-42">
                  {faq.q}
                </span>
                <ChevronDown className={`w-5 h-5 text-gaming-purple-light transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-43" />
              </button>

              <div className={`px-6 overflow-hidden transition-all duration-300 ease-in-out ${openIndex === index ? 'max-h-48 pb-5 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-44">
                <p className="text-gray-400 leading-relaxed" data-id="element-45">{faq.a}</p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}